// 9fbef606107a605d69c0edbcd8029e5d
import React, { Component } from 'react';
import dynamic from 'next/dynamic';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import Row from '@tcp/core/src/components/common/atoms/Row';
import {
  getIsQnAWebEnabled,
  getPageNameFromState,
  getIsDynamicSizeChartEnabled,
  getIsStyleColorRnREnabled,
} from '@tcp/core/src/reduxStore/selectors/session.selectors';
import PRODUCTDETAIL_CONSTANTS from '@tcp/core/src/components/features/browse/ProductDetail/container/ProductDetail.constants.js';
import { isClient, getViewportInfo, getIconPath } from '@tcp/core/src/utils';
import DynamicSizeChart from '@tcp/core/src/components/common/molecules/DynamicSizeChart';
import errorBoundary from '@tcp/core/src/components/common/hoc/withErrorBoundary/errorBoundary';
import styles, {
  RatingStarGrey,
  RatingOverlay,
  RatingStarLightGrey,
  RatingContainer,
} from '@tcp/core/src/components/features/browse/ProductDetail/styles/PDPTabs.style.js';
import ModuleX from '@tcp/core/src/components/common/molecules/ModuleX/ModuleX.jsx';
import withStyles from '../../../../common/hoc/withStyles';
import { PRODUCT_INFO_PROP_TYPE_SHAPE } from '../../ProductListing/molecules/ProductList/propTypes/productsAndItemsPropTypes';
import ProductDescription from '../molecules/ProductDescription/views';
import ProductReviewsWidgetContainer from '../../ProductListing/molecules/ProductReviewsWidget';
import ProductQnA from '../molecules/ProductQnA';
import { PdpTabsLabels } from './PDPTabs.labels';
import Image from '../../../../common/atoms/Image';
import { getLabelFromCopyOrFromTranslation } from '../../../../../utils/labels/labelUtilty';

const SizeChart = dynamic(() =>
  import(
    // eslint-disable-next-line extra-rules/no-commented-out-code
    /* webpackChunkName: "SizeChart" */ '@tcp/core/src/components/common/molecules/ProductAddToBag/molecules/SizeChart/container'
  )
);

const isMobile = isClient() ? getViewportInfo().isMobile : null;
class PDPNewTabs extends Component {
  constructor(props) {
    super(props);
    this.headerHeight = 0;
    this.accordionRef = React.createRef();
    this.accordionRef.current = {};
    this.state = {
      expandedSection: null,
      shouldRenderReviews: false,
    };
  }

  componentDidMount() {
    const { setPdpTabSectionName, isPDPRedesignEnabled } = this.props;
    setPdpTabSectionName('features');
    if (isPDPRedesignEnabled) {
      this.setState({ expandedSection: 'features' });
    }
    const headerElement = document.querySelector('header');
    if (headerElement) {
      this.headerHeight = headerElement.offsetHeight + 100;
    }

    this.setState({ shouldRenderReviews: true });
  }

  static getDerivedStateFromProps(nextProps) {
    const { isPDPRedesignEnabled, activeTabSection } = nextProps;

    if (isPDPRedesignEnabled && activeTabSection) {
      return { expandedSection: activeTabSection };
    }
    return null;
  }

  handleRatingClick = (value) => {
    this.setState({ starRatingClicked: value });
  };

  handleToggle = ({ sec }) => {
    const { setPdpTabSectionName } = this.props;
    const { expandedSection } = this.state;
    if (expandedSection === sec) {
      setPdpTabSectionName('');
      this.setState({ expandedSection: '' });
    } else {
      setPdpTabSectionName(sec);
    }
    if (expandedSection && sec !== expandedSection && this.accordionRef.current[expandedSection]) {
      const element = this.accordionRef.current[expandedSection];
      const topPosition =
        element.getBoundingClientRect().top + window.pageYOffset - this.headerHeight;

      window.scrollTo({
        top: topPosition,
        behavior: 'auto',
      });
    }
  };

  createClickOrKeyDownHandler = (sec) => (event) => {
    requestAnimationFrame(() => {
      if (event.type === 'click' || event.key === 'Enter' || event.key === ' ') {
        this.handleToggle({ sec });
      }
    });
  };

  getAccordionItemClass = (index) => {
    return `tab-accordion-item ${index === 0 ? 'tab-top-border' : ''}`;
  };

  renderReviews = (tabs, productInfo) => {
    const { ratings, unbxdRatings } = productInfo;
    const rating = ratings || unbxdRatings || 0;
    return (
      tabs?.value === 'reviews' && (
        <div className="tab-raing-wrapper">
          <span className="tab-rating-count">{rating}</span>
          <RatingContainer>
            <RatingOverlay ratings={rating}>
              <RatingStarGrey src={getIconPath('stars-rating')} />
            </RatingOverlay>
            <RatingStarLightGrey src={getIconPath('stars-rating')} />
          </RatingContainer>
        </div>
      )
    );
  };

  isActiveTab = (activeTabSection, tabValue) => {
    return activeTabSection === tabValue;
  };

  checkforReviesorSizeChart = (sec) => sec === 'reviews' || sec === 'sizeChart';

  checkActiveTabIndex = (expandedSection, sec) => expandedSection === sec;

  getAccordionIconClass = (sec) => {
    const { expandedSection } = this.state;
    return `tab-accordion-icon ${expandedSection === sec ? 'rotate' : ''}`;
  };

  getAccordionHeaderClass = (sec) => {
    const { expandedSection } = this.state;
    return `tab-accordion-header ${expandedSection === sec ? 'expanded' : ''}`;
  };

  getPdpTabs = (PDP_TABS_WITH_QNA, PDP_TABS) => {
    const { isQnAWebEnabled } = this.props;
    return isQnAWebEnabled ? PDP_TABS_WITH_QNA : PDP_TABS;
  };

  isGiftCardAndSizeChart = (productInfo, tabValue) => {
    return productInfo.isGiftCard && tabValue === 'sizeChart';
  };

  getTabClassName = (activeTabSection, tabValue) => {
    return `tab-buttons ${this.isActiveTab(activeTabSection, tabValue) ? 'pdp-active-tab' : ''}`;
  };

  reorderSections = (sections) => {
    const sectionsCopy = [...sections];
    const qnaIndex = sectionsCopy?.findIndex((section) => section?.value === 'qna');
    const sizeChartIndex = sectionsCopy?.findIndex((section) => section?.value === 'sizeChart');
    const shippingIndex = sectionsCopy.findIndex((section) => section?.value === 'shipping');
    // Only swap if both elements are present
    if (qnaIndex !== -1 && sizeChartIndex !== -1) {
      const temp = sectionsCopy[qnaIndex];
      sectionsCopy[qnaIndex] = sectionsCopy[sizeChartIndex];
      sectionsCopy[sizeChartIndex] = temp;
    }
    // Move 'shipping' to the last index if it exists
    if (shippingIndex !== -1) {
      const [shippingSection] = sectionsCopy.splice(shippingIndex, 1);
      sectionsCopy.push(shippingSection);
    }
    return sectionsCopy;
  };

  checkToRenderShippingTab = (
    sections,
    shippingAndReturnsModuleXContent,
    isShippedAndReturnsTabEnabled
  ) => {
    const sectionsCopy = [...sections];
    if (isShippedAndReturnsTabEnabled && shippingAndReturnsModuleXContent?.richText) {
      return sectionsCopy;
    }
    return sectionsCopy?.filter((tab) => tab?.value !== 'shipping');
  };

  renderSizeChart = ({
    sizeChartDetails,
    categoryPathMap,
    quickViewLabels,
    primaryBrand,
    alternateBrand,
    activeTabSection,
    isDynamicSizeChartEnabled,
    isNewPJPPDPRedesignEnabled,
    checkPageName,
    sizeChartImageURL,
  }) => {
    const content1 =
      checkPageName === 'pdp' && isDynamicSizeChartEnabled ? (
        <DynamicSizeChart primaryBrand={primaryBrand} />
      ) : (
        <SizeChart
          sizeChartDetails={sizeChartDetails}
          labels={{
            sizeChart: getLabelFromCopyOrFromTranslation(
              'PLP.plpTiles.lbl_size_chart',
              PdpTabsLabels
            ),
          }}
          categoryPath2Map={categoryPathMap}
          quickViewLabels={quickViewLabels}
          primaryBrand={primaryBrand}
          alternateBrand={alternateBrand}
          isNewPJPPDPRedesignEnabled={isNewPJPPDPRedesignEnabled}
          hideSizeGuideButton
          activeTabSection={activeTabSection}
        />
      );
    return sizeChartImageURL ? <Image id="altSizeChart" src={sizeChartImageURL} /> : content1;
  };

  renderShippingContent = (isEnabled, content) => {
    if (isEnabled && content?.richText) {
      return <ModuleX richTextList={[{ text: content.richText }]} />;
    }
    return null;
  };

  renderTabContent = (sec) => {
    const { productInfo, productDetails, isNewPJPPDPRedesignEnabled, isPDPRedesignEnabled } =
      this.props;
    const { reviewsCount, unbxdReviewsCount } = productInfo;
    const reviews = reviewsCount || unbxdReviewsCount;

    switch (sec) {
      case 'shipping':
        return this.renderShippingContent(
          this.props.isShippedAndReturnsTabEnabled,
          this.props.shippingAndReturnsModuleXContent
        );

      case 'reviews':
        return (
          <ProductReviewsWidgetContainer
            reviewsCount={reviews}
            ratingsProductId={productInfo?.ratingsProductId}
            bazaarVoice={productDetails?.currentProduct?.bazaarVoice}
            starRatingClicked={true}
            handleRatingClick={this.handleRatingClick}
            isNewPJPPDPRedesignEnabled={isNewPJPPDPRedesignEnabled}
            isPDPtab
            isPDPRedesignEnabled={isPDPRedesignEnabled}
          />
        );

      case 'hidden-reviews':
        return (
          <div
            id="hidden-review-widget"
            style={{
              visibility: 'hidden',
              height: 0,
              overflow: 'hidden',
              position: 'absolute',
            }}
          >
            <ProductReviewsWidgetContainer
              reviewsCount={reviews}
              ratingsProductId={productInfo?.ratingsProductId}
              bazaarVoice={productDetails?.currentProduct?.bazaarVoice}
              starRatingClicked={true}
              handleRatingClick={this.handleRatingClick}
              isNewPJPPDPRedesignEnabled={isNewPJPPDPRedesignEnabled}
              isPDPtab
              isPDPRedesignEnabled={isPDPRedesignEnabled}
            />
          </div>
        );

      case 'qna':
        return (
          <ProductQnA
            productSKU={productInfo?.ratingsProductId}
            isPDPRedesignEnabled={isPDPRedesignEnabled}
            isStyleColorRnREnabled={this.props.isStyleColorRnREnabled}
          />
        );

      case 'sizeChart':
        return this.renderSizeChart({
          sizeChartDetails: this.props.sizeChartDetails,
          categoryPathMap: this.props.categoryPathMap,
          quickViewLabels: this.props.quickViewLabels,
          primaryBrand: this.props.primaryBrand,
          alternateBrand: this.props.alternateBrand,
          activeTabSection: this.props.activeTabSection,
          isDynamicSizeChartEnabled: this.props.isDynamicSizeChartEnabled,
          isNewPJPPDPRedesignEnabled: this.props.isNewPJPPDPRedesignEnabled,
          checkPageName: this.props.checkPageName,
          sizeChartImageURL: this.props.sizeChartImageURL,
        });

      case 'features':
      default:
        return (
          <ProductDescription
            productId={this.props.itemPartNumber}
            productInfo={productInfo}
            shortDescription={this.props.shortDescription}
            longDescription={this.props.longDescription}
            color={this.props.itemColorObj?.color?.name}
            isPDP
            TCPStyleColor={this.props.TCPStyleColor}
            wishList={this.props.wishList}
            variantNumber={this.props.variantNumber}
            isNewPDPEnabled={this.props.isNewPDPEnabled}
            primaryBrand={this.props.primaryBrand}
            isShowMore={!isMobile}
            isNewPJPPDPRedesignEnabled={this.props.isNewPJPPDPRedesignEnabled}
            isESGBadgePDPBackABEnabled={this.props.isESGBadgePDPBackABEnabled}
            pdpTabview
          />
        );
    }
  };

  renderAccordionContent = (sec) => {
    const isReviewTab = sec === 'reviews';
    const isExpanded = this.checkActiveTabIndex(this.state.expandedSection, sec);
    const shouldRender = isExpanded || (isReviewTab && this.state.shouldRenderReviews);

    if (!shouldRender) return null;

    return (
      <div
        className="tab-accordion-content"
        style={{
          visibility: isReviewTab && !isExpanded ? 'hidden' : 'visible',
          height: isReviewTab && !isExpanded ? 0 : 'auto',
          overflow: 'hidden',
          position: isReviewTab && !isExpanded ? 'absolute' : 'relative',
        }}
      >
        {this.renderTabContent(sec)}
      </div>
    );
  };

  renderTabs = (tabs) => {
    return tabs.map((tab, index) => {
      if (this.isGiftCardAndSizeChart(this.props.productInfo, tab.value)) {
        return null;
      }
      return (
        <div
          key={`tab-${tab.value?.toLocaleLowerCase()}`}
          id={`tab-${tab.value?.toLocaleLowerCase()}`}
          className={this.getAccordionItemClass(index)}
        >
          <div
            ref={(el) => {
              this.accordionRef.current[tab.value] = el;
            }}
            role="tab"
            tabIndex="0"
            id={`tab-title-${tab.value?.toLocaleLowerCase()}`}
            className={this.getAccordionHeaderClass(tab.value)}
            onClick={this.createClickOrKeyDownHandler(tab.value)}
            onKeyDown={this.createClickOrKeyDownHandler(tab.value)}
          >
            <span className={`tab-accordion-title  `}>{tab.key}</span>
            <div className="tab-arrow-wrapper">
              {this.renderReviews(tab, this.props.productInfo)}
              <span className={this.getAccordionIconClass(tab.value)}>
                <Image src={getIconPath('icon-carrot-grey-large')} />
              </span>
            </div>
          </div>
          {this.renderAccordionContent(tab.value)}
        </div>
      );
    });
  };

  render() {
    const {
      className,
      isPDPRedesignEnabled,
      shippingAndReturnsModuleXContent,
      isShippedAndReturnsTabEnabled,
    } = this.props;
    const { PDP_TABS, PDP_TABS_WITH_QNA } = PRODUCTDETAIL_CONSTANTS;
    const pdpTabs = this.getPdpTabs(PDP_TABS_WITH_QNA, PDP_TABS);

    if (isPDPRedesignEnabled) {
      const sortedPdpTabs = this.reorderSections(pdpTabs);
      const filteredTabs = this.checkToRenderShippingTab(
        sortedPdpTabs,
        shippingAndReturnsModuleXContent,
        isShippedAndReturnsTabEnabled
      );
      return (
        <div className={`${className} reviews-anchoring-wrapper`} id="pdp-tab-wrapper">
          <div className="pdp-redesign-tab-structure" role="tablist">
            {this.renderTabs(filteredTabs)}
          </div>
        </div>
      );
    }
    return (
      <div className={`${className} reviews-anchoring-wrapper`} id="pdp-tab-wrapper">
        <Row className="pdp-redesign-tab-structure" role="tablist">
          {pdpTabs?.map((tabs) => {
            return (
              <button
                id={`tab-${tabs.value?.toLocaleLowerCase()}`}
                type="button"
                role="tab"
                aria-selected={this.isActiveTab(this.props.activeTabSection, tabs.value)}
                className={this.getTabClassName(this.props.activeTabSection, tabs.value)}
                aria-controls={`tab-structure-${tabs.value?.toLocaleLowerCase()}`}
                tabIndex={this.isActiveTab(this.props.activeTabSection, tabs.value) ? 0 : -1}
                onClick={() => this.props.setPdpTabSectionName(tabs.value)}
              >
                {tabs.key}
              </button>
            );
          })}
        </Row>
        {this.renderTabContent()}
      </div>
    );
  }
}

PDPNewTabs.propTypes = {
  className: PropTypes.string,
  productInfo: PRODUCT_INFO_PROP_TYPE_SHAPE,
  productDetails: PropTypes.shape({}),
  itemPartNumber: PropTypes.string,
  shortDescription: PropTypes.string,
  longDescription: PropTypes.string,
  isNewPDPEnabled: PropTypes.bool,
  wishList: PropTypes.func.isRequired,
  isNewPJPPDPRedesignEnabled: PropTypes.bool,
  isESGBadgePDPBackABEnabled: PropTypes.bool,
  isPDPRedesignEnabled: PropTypes.bool,
  variantNumber: PropTypes.string,
  isDynamicSizeChartEnabled: PropTypes.bool,
  isShippedAndReturnsTabEnabled: PropTypes.bool, // Added prop type validation
  shippingAndReturnsModuleXContent: PropTypes.object, // Added prop type validation
};

PDPNewTabs.defaultProps = {
  className: '',
  productInfo: {},
  productDetails: {},
  itemPartNumber: '',
  shortDescription: '',
  longDescription: '',
  isNewPDPEnabled: false,
  isNewPJPPDPRedesignEnabled: false,
  isESGBadgePDPBackABEnabled: false,
  isPDPRedesignEnabled: false,
  variantNumber: null,
  isDynamicSizeChartEnabled: false,
  isShippedAndReturnsTabEnabled: false, // Added default value
  shippingAndReturnsModuleXContent: {}, // Added default value
};

const mapStateToProps = (state) => ({
  isQnAWebEnabled: getIsQnAWebEnabled(state),
  isDynamicSizeChartEnabled: getIsDynamicSizeChartEnabled(state),
  checkPageName: getPageNameFromState(state),
  isStyleColorRnREnabled: getIsStyleColorRnREnabled(state),
});

const PDPNewTabsContainer = connect(mapStateToProps, null)(PDPNewTabs);
export default errorBoundary(withStyles(PDPNewTabsContainer, styles));
